import React, { useContext, useState } from "react";
import { Paper, Grid, TableRow, TableCell } from "@material-ui/core";
import {
  IconButtonDatatable,
  InputFileCustom,
  InputTextArea,
  MasterButton,
  ModalDeleteConfirm,
  TableWrapper,
} from "App/Component/ui";
import { downloadPDF, STYLE_MASTER_FA } from "../helpers";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { DownloadIcon, TrashIcon } from "App/Assets";
import { FormContext } from "../context/FormContext";
import { STATUS_PENGERJAAN_SELESAI } from "../../HelpDesk/helpers";

export const urlUpload = "/wmsAsset/maintance/add-file";

export default function FormUploadFile({ file, setFile, setNewDataReqList }) {
  const classes = STYLE_MASTER_FA();
  const SHOW_LOAD_BUTTON = {
    label: "Upload",
    color: "green",
    state: false,
    disabled: false,
  };
  const [downloadIdFile, setdownloadIdFile] = useState("");
  const [disabledFile, setDisabledFile] = useState(SHOW_LOAD_BUTTON);
  const [dataRemarkFile, setDataRemarkFile] = useState("");
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const { filePDF, formData } = useContext(FormContext);
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: filePDF,
    orderByDefault: "name",
    orderByRow: ["name", "id"],
  });

  const headCellsTOR = [
    {
      id: "no",
      disablePadding: false,
      label: "NO",
      align: "center",
      sort: false,
      maxWidth: "80px",
    },
    {
      id: "act",
      disablePadding: false,
      label: "ACTION",
      align: "center",
      sort: true,
      maxWidth: "80px",
    },
    {
      id: "id",
      disablePadding: false,
      label: "ID",
      align: "center",
      sort: true,
      maxWidth: "80px",
    },
    {
      id: "file_name",
      disablePadding: false,
      label: "NAMA FILE",
      align: "left",
      sort: true,
      minWidth: "400px",
    },
    {
      id: "remark",
      disablePadding: false,
      label: "CATATAN",
      align: "left",
      sort: true,
      minWidth: "400px",
    },
  ];

  const handleClickUpload = async () => {
    setDisabledFile(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(file)) {
        defaultToastError("Harap pilih file terlebih dahulu");
        setDisabledFile(SHOW_LOAD_BUTTON);
      } else {
        const newFormData = new FormData();
        newFormData.append("id_service_header", formData.id);
        newFormData.append("AssetFile", file);
        newFormData.append("remark", dataRemarkFile);

        const res = await instance4.post(urlUpload, newFormData);

        if (res.data.status === 200) {
          await setNewDataReqList(formData.id);
          setDisabledFile(SHOW_LOAD_BUTTON);
          defaultToastSuccess(res.data.message);
          setFile(null);
          setDataRemarkFile("");
        } else {
          defaultToastError(res.data.message);
          setDisabledFile(SHOW_LOAD_BUTTON);
        }
      }
    } catch (error) {
      setDisabledFile(SHOW_LOAD_BUTTON);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const deleteById = async (id) => {
    try {
      const api = await instance4.post("/wmsAsset/maintance/delete-file", {
        id,
      });
      if (api.data.status === 200) {
        return {
          state: true,
          message: api.data.message,
        };
      } else {
        return {
          state: false,
          message: api.data?.message,
        };
      }
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
  };

  async function deleteList() {
    const res = await deleteById(downloadIdFile);

    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewDataReqList(formData.id);
    } else {
      defaultToastError(res.message);
    }
    setShowModalDeleteConfirm(false);
  }

  function handleClickDelete(row) {
    setdownloadIdFile(row);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  return (
    <Paper className={classes.paper}>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <p className="fw-600 mt-1">FILE PENDUKUNG/PELENGKAP MAINTENANCE</p>
      {/* <div  
      style={{
          display: formData.user_request === 0 ? "none" : "block",
        }}> */}
      {formData.status_service !== STATUS_PENGERJAAN_SELESAI && (
        <Grid container spacing={2}>
          <Grid
            item
            sm={12}
            style={{
              position: "relative",
            }}
          >
            <label
              htmlFor="fileMT"
              style={{
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}
            >
              Pilih File
            </label>
            <InputFileCustom
              convertToBase64={false}
              label={"Upload File"}
              name={"fileMT"}
              id={"fileMT"}
              initialNameFile={file}
              setFile={setFile}
              accept={".jpg, .jpeg, .png, .xlsx, .docx, .pdf"}
            />
            <label
              style={{
                position: "absolute",
                left: "8px",
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}
            >
              *File yang diizinkan .jpg, .jpeg, .png, .xlsx, .docx, dan .pdf;
              Maksimal file berukuran 2MB
            </label>
          </Grid>
          <Grid item sm={10}>
            <InputTextArea
              name="remark"
              label="Catatan"
              id="remark"
              placeholder="Catatan File Pendukung/Pelengkap"
              value={dataRemarkFile}
              onChange={(e) => setDataRemarkFile(e.target.value)}
            />
          </Grid>
          <Grid item sm={2}>
            <MasterButton
              type="submit"
              name={disabledFile.label}
              disabled={disabledFile.state}
              color={disabledFile.color}
              size="lg"
              onClick={() =>
                disabledFile.disabled ? null : handleClickUpload()
              }
              style={{
                padding: "0.6rem 2rem",
                fontSize: "15px",
                marginTop: "25px",
              }}
            />
          </Grid>
        </Grid>
      )}

      {/* </div> */}
      <div className="mt-2">
        <TableWrapper
          setQ={setQ}
          withExportButton={false}
          withAddButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={filePDF}
          headCells={headCellsTOR}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center"
                  >
                    {index + 1}.
                  </TableCell>

                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center"
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}
                    >
                      <IconButtonDatatable
                        onClick={() => downloadPDF(row.id, row.name)}
                      >
                        <DownloadIcon />
                      </IconButtonDatatable>
                      {formData.status_service !==
                        STATUS_PENGERJAAN_SELESAI && (
                        <IconButtonDatatable
                          onClick={() => handleClickDelete(row.id)}
                        >
                          <TrashIcon />
                        </IconButtonDatatable>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="center">{row?.id}</TableCell>
                  <TableCell align="left">{row?.file_name}</TableCell>
                  <TableCell align="left">{row?.remark}</TableCell>
                </TableRow>
              );
            })}
        </TableWrapper>
      </div>
    </Paper>
  );
}
